import React, { Suspense } from 'react';
import { useNavigation } from 'react-router-dom';
import { LoadingSpinner } from '../loading/LoadingState';

interface RouteLoaderProps {
  children: React.ReactNode;
}

const RouteLoader: React.FC<RouteLoaderProps> = ({ children }) => {
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';

  return (
    <>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
          }}
        >
          <LoadingSpinner size="lg" />
        </div>
      )}
      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center min-vh-100">
            <LoadingSpinner size="lg" />
          </div>
        }
      >
        {children}
      </Suspense>
    </>
  );
};

export default RouteLoader;